import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=497e6316&"
import script from "./HomeMain.vue?vue&type=script&lang=js&"
export * from "./HomeMain.vue?vue&type=script&lang=js&"
import style0 from "./HomeMain.vue?vue&type=style&index=0&id=497e6316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports